import moment from "moment"
class accessControl {
  constructor(
    date,
    card,
    event,
    eventDescript,
    pca,
    dfiAlias,
    movimId,
    eventId,
    dfiId,
    dfi,
    dfiDescript
  ) {
    this.date = moment(date).utc().format('DD-MM-YYYY HH:mm');
    this.card = card;
    this.event = event;
    this.eventDescript = eventDescript;
    this.pca = pca;
    this.dfiAlias = dfiAlias;
    this.movimId = movimId;
    this.eventId = eventId;
    this.dfiId = dfiId;
    this.dfi = dfi;
    this.dfiDescript = dfiDescript;
  
  }
  static fromJson({
    Fecha,
    Tarjeta,
    Evento,
    EventoDescript,
    Pca,
    DfiAlias,
    MovimId,
    EventoId,
    DfiId,
    Dfi,
    DfiDescript,
  }) {
    return new accessControl(
        Fecha,
        Tarjeta,
        Evento,
        EventoDescript,
        Pca,
        DfiAlias,
        MovimId,
        EventoId,
        DfiId,
        Dfi,
        DfiDescript,
    );
  }
}
export default accessControl;
